/*
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { InjectionToken } from '@angular/core';

export const CACHE_NONCE = new InjectionToken<number>('cacheNonce');
